<div class="col-sm-2 clear-padding-right">{{ aktivitaet.who }}</div>
<div class="col-sm-2 clear-padding-right">{{ aktivitaet.till | date: 'dd.MM.yyyy'}}</div>
<div class="col-sm-6 clear-padding-right" [innerHTML]="aktivitaet.text"></div>
<div class="col-sm-1 clear-padding-right">{{ 'adura.aktivitaet.status.' + aktivitaet.status | translate }}</div>
